/*
 * @Author:
 * @LastEditTime: 2022-04-18 14:50:56
 * @Description: 后台管理
 */
export default [
  {
    id: '44aadccc-1e1c-42d6-b808-9a490babbc6a',
    name: 'educational-training-management',
    path: '/educational-training-management-sm',
    meta: { title: '教育培训' },
    children: [
      {
        id: 'e80d37ad-65d5-46a3-a97d-4f98756ca821',
        path: 'statistics-analysis',
        name: 'statisticsAnalysis',
        meta: { title: '总览面板' },
        component(resolve) {
          require(['./views/statistics/index'], resolve)
        },
      },
      {
        id: 'e90128aa-9cd2-42e0-b230-fbf5a73633ed',
        path: 'train-manage',
        name: 'trainManage',
        meta: { title: '培训管理' },
        children: [
          {
            id: '5ec06af5-43fa-46e6-9b0f-363f07d86dda',
            path: 'courseware-maintenance',
            name: 'coursewareMaintenance',
            component(resolve) {
              require(['./views/trainManage/HomeList'], resolve)
            },
            meta: {
              title: '课件维护',
              keepAlive: false,
              operations: {
                create: {
                  id: 0,
                  name: 'create',
                  desc: '新增',
                  access: true,
                },
                update: {
                  id: 1,
                  name: 'update',
                  desc: '编辑',
                  access: true,
                },
                delete: {
                  id: 2,
                  name: 'delete',
                  desc: '删除',
                  access: true,
                },
                read: {
                  id: 3,
                  name: 'read',
                  desc: '查看',
                  access: true,
                },
                play: {
                  id: 4,
                  name: 'play',
                  desc: '播放',
                  access: true,
                },
              },
            },
          },
          {
            id: '275c29be-30c9-49d5-bc7d-8820b0064c29',
            path: 'train-plan',
            name: 'trainPlan',
            component(resolve) {
              require(['./views/trainManage/PlanList'], resolve)
            },
            meta: {
              title: '培训计划',
              keepAlive: false,
              operations: {
                update: {
                  id: 1,
                  name: 'update',
                  desc: '编辑',
                  access: true,
                },
                delete: {
                  id: 2,
                  name: 'delete',
                  desc: '删除',
                  access: true,
                },
                read: {
                  id: 3,
                  name: 'read',
                  desc: '查看',
                  access: true,
                },
                publish: {
                  id: 4,
                  name: 'publish',
                  desc: '发布',
                  access: true,
                },
              },
            },
          },
          {
            id: 'f6f2f636-fc62-45f7-a576-547dcfad5f89',
            path: 'train-task',
            name: 'trainTask',
            component(resolve) {
              require(['./views/trainManage/TaskList'], resolve)
            },
            meta: {
              title: '培训任务',
              keepAlive: false,
              operations: {
                start: {
                  id: 1,
                  name: 'start',
                  desc: '开始培训',
                  access: true,
                },
                continue: {
                  id: 2,
                  name: 'continue',
                  desc: '继续培训',
                  access: true,
                },
                read: {
                  id: 3,
                  name: 'read',
                  desc: '查看记录',
                  access: true,
                },
              },
            },
          },
          {
            id: 'd98f43f6-d208-45ab-874e-2a1b67009826',
            path: 'training',
            name: 'training',
            component(resolve) {
              require(['./components/trainManage/ConductTraining'], resolve)
            },
            meta: {
              title: '开始培训',
              hidden: true,
              tabnab: false,
              operations: {},
              activeMenu: '/educational-training-management-sm/train-manage/train-task',
            },
          },
          {
            id: '27fdda3e-f1b7-4e9b-870b-714ab406dc25',
            path: 'train-record',
            name: 'trainRecord',
            component(resolve) {
              require(['./views/trainManage/RecordList'], resolve)
            },
            meta: {
              title: '培训记录',
              keepAlive: false,
              operations: {
                read: {
                  id: 3,
                  name: 'read',
                  desc: '查看',
                  access: true,
                },
              },
            },
          },
        ],
      },
      {
        id: '5adc6f61-fea1-44fc-9dbc-f84dd63fdc95',
        path: 'exam-manage',
        name: 'exam-manage',
        meta: { title: '考试管理' },
        children: [
          {
            id: 'bd92123b-35d6-41e4-a4b1-c732638b0ad5',
            path: 'paper-manage',
            name: 'paper-manage',
            component(resolve) {
              require(['./views/examManage/PaperManage'], resolve)
            },
            meta: {
              title: '试卷管理',
              keepAlive: false,
              operations: {
                create: {
                  id: 0,
                  name: 'create',
                  desc: '新增',
                  access: true,
                },
                update: {
                  id: 1,
                  name: 'update',
                  desc: '编辑',
                  access: true,
                },
                delete: {
                  id: 2,
                  name: 'delete',
                  desc: '删除',
                  access: true,
                },
                read: {
                  id: 3,
                  name: 'read',
                  desc: '查看',
                  access: true,
                },
              },
            },
          },
          {
            id: 'd52a89e3-2033-4b42-a9c1-31bb1c29045a',
            path: 'exam-plan',
            name: 'exam-plan',
            component(resolve) {
              require(['./views/examManage/ExamPlan'], resolve)
            },
            meta: {
              title: '考试计划',
              keepAlive: false,
              operations: {
                create: {
                  id: 0,
                  name: 'create',
                  desc: '新增',
                  access: true,
                },
                update: {
                  id: 1,
                  name: 'update',
                  desc: '编辑',
                  access: true,
                },
                delete: {
                  id: 2,
                  name: 'delete',
                  desc: '删除',
                  access: true,
                },
                read: {
                  id: 3,
                  name: 'read',
                  desc: '查看',
                  access: true,
                },
                auditPlan: {
                  id: 4,
                  name: 'auditPlan',
                  desc: '审批',
                  access: true,
                },
                submitPlan: {
                  id: 5,
                  name: 'submitPlan',
                  desc: '提交',
                  access: true,
                },
                readFlow: {
                  id: 6,
                  name: 'readFlow',
                  desc: '查看流程',
                  access: true,
                },
                publish: {
                  id: 7,
                  name: 'publish',
                  desc: '发布',
                  access: true,
                },
                withdraw: {
                  id: 8,
                  name: 'withdraw',
                  desc: '撤回',
                  access: true,
                },
                change: {
                  id: 9,
                  name: 'change',
                  desc: '变更',
                  access: true,
                },
                export: {
                  id: 10,
                  name: 'export',
                  desc: '导出',
                  access: true,
                },
              },
            },
          },
          {
            id: '5f7ff966-228a-4be3-8878-70a27ee9a43e',
            path: 'details',
            name: 'details',
            component: () => {
              return import('./views/examManage/AddExamPlan')
            },
            meta: {
              title: '详情',
              hidden: true,
              tabnab: false,
            },
          },
          {
            id: '1c7b41e3-11c4-4862-8557-f06f4138e29f',
            path: 'question-task',
            name: 'question-task',
            component(resolve) {
              require(['./views/QuestionTask'], resolve)
            },
            meta: {
              title: '考试任务',
              keepAlive: false,
              operations: {
                read: {
                  id: 0,
                  name: 'read',
                  desc: '查看',
                  access: true,
                },
                startExam: {
                  id: 1,
                  name: 'startExam',
                  desc: '开始考试',
                  access: true,
                },
              },
            },
          },
          {
            id: '6c282f24-c9d0-4ea3-abe8-32e678b6ab0a',
            path: 'online-question',
            name: 'online-question',
            component(resolve) {
              require(['./views/OnlineQuestion'], resolve)
            },
            meta: {
              hidden: true,
              tabnab: false,
              title: '在线考试',
              keepAlive: false,
              operations: {},
            },
          },
          {
            id: '49b88f11-a069-4d47-8d52-35cf82b0a864',
            path: 'paper-inspection',
            name: 'paperInspection',
            component(resolve) {
              require(['./views/examManage/ExaminePaper'], resolve)
            },
            meta: {
              title: '阅卷管理',
              keepAlive: false,
              operations: {
                read: {
                  id: 0,
                  name: 'read',
                  desc: '阅卷',
                  access: true,
                },
              },
            },
          },
          {
            id: '39affe09-b523-41dc-b781-5ab5fd4ad113',
            path: 'examine-paper',
            name: 'examinePaper',
            component(resolve) {
              require(['./components/examManage/PaperScore'], resolve)
            },
            meta: {
              title: '开始阅卷',
              hidden: true,
              tabnab: false,
              operations: {},
              activeMenu: '/educational-training-management-sm/exam-manage/paper-inspection',
            },
          },
          {
            id: '3e6afc30-8cd7-48e1-8ef0-bf6cbdd0dd4f',
            path: 'exam-record',
            name: 'examRecord',
            component(resolve) {
              require(['./views/examManage/ExamRecord'], resolve)
            },
            meta: {
              title: '考试记录(管理员)',
              keepAlive: false,
              operations: {
                export: {
                  id: 0,
                  name: 'export',
                  desc: '导出',
                  access: true,
                },
                anew: {
                  id: 1,
                  name: 'anew',
                  desc: '补考',
                  access: true,
                },
                read: {
                  id: 2,
                  name: 'read',
                  desc: '查看',
                  access: true,
                },
              },
            },
          },
          {
            id: 'd664d16d-e6c0-4a8f-904d-bb2db259e812',
            path: 'exam-record-student',
            name: 'examRecordStudent',
            component(resolve) {
              require(['./views/examManage/RecordStudy'], resolve)
            },
            meta: {
              title: '考试记录(考生)',
              keepAlive: false,
              operations: {
                read: {
                  id: 2,
                  name: 'read',
                  desc: '查看',
                  access: true,
                },
              },
            },
          },
          {
            id: 'cbc410bc-a250-47c8-b45b-fa8b9d7a4f37',
            path: 'exam-record-info',
            name: 'examRecordInfo',
            component(resolve) {
              require(['./components/examManageConstructionUnit/ExamRecord'], resolve)
            },
            meta: {
              title: '考试记录详情',
              hidden: true,
              tabnab: false,
              operations: {},
              activeMenu: '/educational-training-management-sm/exam-manage/exam-record',
            },
          },
        ],
      },
      {
        id: '844b575a-7e39-47b5-a4a7-e21750a698ed',
        path: 'exam-manage-construction-unit',
        name: 'exam-manage-construction-unit',
        meta: { title: '考试管理(参建单位)' },
        children: [
          {
            id: '1a129e25-b823-4052-9fb3-9807887adb35',
            path: 'exam-plan',
            name: 'exam-plan',
            component(resolve) {
              require(['./views/examManageConstructionUnit/ExamPlan'], resolve)
            },
            meta: {
              title: '考试计划(参建单位)',
              keepAlive: false,
              operations: {
                create: {
                  id: 0,
                  name: 'create',
                  desc: '新增',
                  access: true,
                },
                update: {
                  id: 1,
                  name: 'update',
                  desc: '编辑',
                  access: true,
                },
                delete: {
                  id: 2,
                  name: 'delete',
                  desc: '删除',
                  access: true,
                },
                read: {
                  id: 3,
                  name: 'read',
                  desc: '查看',
                  access: true,
                },
                publish: {
                  id: 4,
                  name: 'publish',
                  desc: '发布',
                  access: true,
                },
              },
            },
          },
          {
            id: 'f8b7c107-d1e5-4fd6-b9bb-57962669ecd6',
            path: 'question-task',
            name: 'question-task',
            component(resolve) {
              require(['./views/examManageConstructionUnit/QuestionTask'], resolve)
            },
            meta: {
              title: '考试任务(参建单位)',
              keepAlive: false,
              operations: {
                startExam: {
                  id: 0,
                  name: 'startExam',
                  desc: '开始考试',
                  access: true,
                },
                makeupExam: {
                  id: 1,
                  name: 'makeupExam',
                  desc: '补考',
                  access: true,
                },
              },
            },
          },
          {
            id: '2ec7312a-90e3-4417-a451-2f52e0360219',
            path: 'online-question',
            name: 'online-question',
            component(resolve) {
              require(['./views/examManageConstructionUnit/OnlineQuestion'], resolve)
            },
            meta: {
              hidden: true,
              title: '在线考试',
              keepAlive: false,
              operations: {},
            },
          },
          {
            id: '25883e76-7901-4bf2-9dea-3af5660a19da',
            path: 'exam-record',
            name: 'examRecord',
            component(resolve) {
              require(['./views/examManageConstructionUnit/ExamRecord'], resolve)
            },
            meta: {
              title: '考试记录(参建单位)',
              keepAlive: false,
              operations: {
                export: {
                  id: 0,
                  name: 'export',
                  desc: '导出',
                  access: true,
                },
                viewPaper: {
                  id: 1,
                  name: 'viewPaper',
                  desc: '查看试卷',
                  access: true,
                },
              },
            },
          },
          {
            id: '5618e16f-84d0-43d2-b09b-ad89f978848c',
            path: 'exam-record-info',
            name: 'examRecordInfo',
            component(resolve) {
              require(['./components/examManageConstructionUnit/ExamRecord'], resolve)
            },
            meta: {
              title: '考试记录详情',
              hidden: true,
              tabnab: false, 
              operations: {},
              // activeMenu: '/educational-training-management-sm/exam-manage-construction-unit/exam-record',
            },
          },
        ],
      },
      {
        id: 'dcea411a-52a2-47f7-9ef9-7a97e6dc6e15',
        path: 'topic',
        name: 'topic',
        meta: { title: '题库管理' },
        children: [
          {
            id: '65529b2b-139d-49da-bbb5-0750c007eef5',
            path: 'topic-origin',
            name: 'topic-origin',
            component(resolve) {
              require(['./views/TopicOriginManagement'], resolve)
            },
            meta: {
              title: '题源管理',
              keepAlive: false,
              operations: {
                create: {
                  id: 0,
                  name: 'create',
                  desc: '新增',
                  access: true,
                },
                update: {
                  id: 1,
                  name: 'update',
                  desc: '编辑',
                  access: true,
                },
                delete: {
                  id: 2,
                  name: 'delete',
                  desc: '删除',
                  access: true,
                },
                read: {
                  id: 3,
                  name: 'read',
                  desc: '查看',
                  access: true,
                },
                batchImport: {
                  id: 4,
                  name: 'batchImport',
                  desc: '导入',
                  access: true,
                },
                batchExport: {
                  id: 5,
                  name: 'batchExport',
                  desc: '导出',
                  access: true,
                },
              },
            },
          },
          // {
          //   id: 'a86bbd29-1b56-4874-8bb5-570c09e4a0d8',
          //   path: 'question-bank',
          //   name: 'question-bank',
          //   component(resolve) {
          //     require(['./views/QuestionBankMaintain'], resolve)
          //   },
          //   meta: {
          //     title: '题库维护',
          //     keepAlive: false,
          //     operations: {
          //       create: {
          //         id: 0,
          //         name: 'create',
          //         desc: '新增',
          //         access: true,
          //       },
          //       update: {
          //         id: 1,
          //         name: 'update',
          //         desc: '编辑',
          //         access: true,
          //       },
          //       delete: {
          //         id: 2,
          //         name: 'delete',
          //         desc: '删除',
          //         access: true,
          //       },
          //       read: {
          //         id: 3,
          //         name: 'read',
          //         desc: '查看',
          //         access: true,
          //       },
          //       auditPlan: {
          //         id: 4,
          //         name: 'auditPlan',
          //         desc: '审批',
          //         access: true,
          //       },
          //       submitPlan: {
          //         id: 5,
          //         name: 'submitPlan',
          //         desc: '提交',
          //         access: true,
          //       },
          //       readFlow: {
          //         id: 6,
          //         name: 'readFlow',
          //         desc: '查看流程',
          //         access: true,
          //       },
          //     },
          //   },
          // },
        ],
      },
    ],
  },
]
